/** Translation keys used in the Security module */
export const enum SecurityTextKey {
    ConfigureSsoCardDescriptionEnterprise = 'ConfigureSsoCardDescriptionEnterprise',
    DeviceAuthConfigurationGuideLink = 'DeviceAuthConfigurationGuideLink',
    SecurityOverviewSecurityLevelHigh = 'SecurityOverviewSecurityLevelHigh',
    SecurityOverviewSecurityLevelHighTooltip = 'SecurityOverviewSecurityLevelHighTooltip',
    SecurityOverviewSecurityLevelLow = 'SecurityOverviewSecurityLevelLow',
    SecurityOverviewSecurityLevelLowTooltip = 'SecurityOverviewSecurityLevelLowTooltip',
    SecurityOverviewSecurityLevelMedium = 'SecurityOverviewSecurityLevelMedium',
    SecurityOverviewSecurityLevelMediumTooltip = 'SecurityOverviewSecurityLevelMediumTooltip',
    SecurityOverviewSecurityLevelVeryHigh = 'SecurityOverviewSecurityLevelVeryHigh',
    SecurityOverviewSecurityLevelVeryHighTooltip = 'SecurityOverviewSecurityLevelVeryHighTooltip',
    SecurityOverviewStatsAdminUsers = 'SecurityOverviewStatsAdminUsers',
    SecurityOverviewStatsAdminUsersMmp = 'SecurityOverviewStatsAdminUsersMmp',
    SecurityOverviewStatsAdminUsersTooltip = 'SecurityOverviewStatsAdminUsersTooltip',
    SecurityOverviewStatsPasskeyLogins = 'SecurityOverviewStatsPasskeyLogins',
    SecurityOverviewStatsSecuredAccounts = 'SecurityOverviewStatsSecuredAccounts',
    SecurityOverviewStatsSecuredAccountsTooltip = 'SecurityOverviewStatsSecuredAccountsTooltip',
    SecurityOverviewStatsSecurityFeatures = 'SecurityOverviewStatsSecurityFeatures',
    SecurityOverviewTipsLevelHigh = 'SecurityOverviewTipsLevelHigh',
    SecurityOverviewTipsLevelLow = 'SecurityOverviewTipsLevelLow',
    SecurityOverviewTipsLevelMedium = 'SecurityOverviewTipsLevelMedium',
    SecurityOverviewTipsTitle = 'SecurityOverviewTipsTitle',
    SecurityOverviewTitle = 'SecurityOverviewTitle',
    SecurityOverviewTitleSecurityFeatures = 'SecurityOverviewTitleSecurityFeatures',
    TwoFactorAuthenticationCardExceptions = 'TwoFactorAuthenticationCardExceptions',
}
